<template>
    <section class="community">
        <div class="o-wrapper">
            <div class="o-grid">
                <div class="o-grid__item u-width-full">
                    <div class="community__wrap">
                        <div class="community__details">
                            <div :class="['community__logo', $root.community.isMember ? 'member' : '']">
                                <img :srcset="communityLogoSrcSet" :src="communityLogo" :alt="$root.community.name">
                            </div>

                            <div class="community__content">
                                <h5>{{ $root.community.name }}</h5>
                                <div class="community__info">
                                    <div class="community__stat">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                                            <circle cx="9.5" cy="5.5" r="4.75" stroke="black" stroke-width="1.5"/>
                                            <path
                                                d="M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z"
                                                stroke="black"
                                                stroke-width="1.5"
                                            />
                                        </svg>
                                        <p>{{$simpleStore.formatValue($root.community.members)}} member<span v-if="$root.community.members !== 1">s</span></p>
                                    </div>
                                    <!-- Join button -->
                                    <a
                                        v-if="$root.community.isMember === false"
                                        data-cy="join-community"
                                        href="#"
                                        :class="['button__join']"
                                        @click.prevent="join"
                                        ><p>Join</p></a
                                    >
                                    <!-- Leave button -->
                                    <a
                                        v-if="$root.community.isMember"
                                        class="button__status"
                                        href="#"
                                        @click.prevent="toggleModalLeave"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="32" viewBox="0 0 72 32" fill="none">
                                                <rect width="72" height="32" rx="16" fill="#47AAC0"/>
                                                <path
                                                    d="M37 23.6772C37.4017 22.1406 38.322 20.7725 39.6191 19.7837C40.9162 18.7948 42.5181 18.2401 44.1782 18.2049C45.8383 18.1697 47.4646 18.656 48.8064 19.5888C50.1483 20.5217 51.1314 21.8494 51.6044 23.3675"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M44.6678 15.1797H43.9352C43.0173 15.1797 42.137 14.8319 41.4879 14.2129C40.8389 13.5938 40.4742 12.7543 40.4742 11.8788V11.5767C40.4742 10.6281 40.8693 9.71836 41.5726 9.04762C42.2759 8.37687 43.2297 8.00006 44.2243 8.00006C44.7377 7.99957 45.2462 8.09566 45.7206 8.28281C46.1951 8.46997 46.6262 8.74452 46.9892 9.09077C47.3522 9.43701 47.6401 9.84814 47.8364 10.3006C48.0326 10.7531 48.1333 11.2381 48.1328 11.7277V11.8788C48.1328 12.7543 47.7682 13.5938 47.1191 14.2129C46.47 14.8319 45.5897 15.1797 44.6718 15.1797H44.6678Z"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M18 16.4839L22.3077 21L30 11"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                />
                                            </svg
                                    ></a>
                                    <!-- Invite button -->
                                    <a
                                        v-if="$root.community.isMember"
                                        data-cy="invite-to-community"
                                        href="#"
                                        :class="['button__invite']"
                                        @click.prevent="showInvitePanel"
                                        ><p>Invite</p></a
                                    >
                                </div>
                            </div>
                        </div>

                        <div class="community__search">
                            <community-search></community-search>
                        </div>

                        <div class="community__links">
                            <div class="community__paging u-m-b4 u-m-b2@s">
                                <router-link
                                    :to="'/' + $root.community.url"
                                    v-slot="{
                                        href,
                                        route,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <div>
                                        <a :href="href" @click="navigate">
                                            <h4 :class="[!isExactActive && 'inactive',]">
                                                All Posts
                                            </h4>
                                        </a>
                                    </div>
                                </router-link>
                                <router-link
                                    :to="'/' + $root.community.url + '/official'"
                                    v-slot="{
                                        href,
                                        route,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <div>
                                        <a :href="href" @click="navigate">
                                            <h4 :class="[!isExactActive && 'inactive',]">
                                                <span class="community__tab-full">Official posts</span>
                                                <span class="community__tab-short">Official</span>
                                            </h4>
                                        </a>
                                    </div>
                                </router-link>
                                <router-link
                                    :to="'/' + $root.community.url + '/articles'"
                                    v-slot="{
                                        href,
                                        route,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <div>
                                        <a :href="href" @click="navigate">
                                            <h4 :class="[!isExactActive && 'inactive',]">
                                                Articles
                                            </h4>
                                        </a>
                                    </div>
                                </router-link>
                                <router-link
                                    :to="'/' + $root.community.url + '/reposts'"
                                    v-slot="{
                                        href,
                                        route,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <div>
                                        <a :href="href" @click="navigate">
                                            <h4 :class="[!isExactActive && 'inactive',]">
                                                Reposts
                                            </h4>
                                        </a>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalWindow :show-modal-window="showModalLeave" :close-event="closeLeaveModalEvent">
            <div v-if="$root.community.isMember">
                <img :srcset="communityLogoSrcSet" :src="communityLogo" :alt="$root.community.name" width="60" height="60" class="u-a-center-i">
                <div class="modal-window__links u-a-center">
                    <h5>{{$root.community.name}} Membership</h5>
                    <p>You have been a member since {{new Date($root.community.joined).toDateString()}}</p>
                </div>

                <div class="modal-window__source" @click.prevent="leave">
                    <a href="#">Leave the community?</a>
                </div>
            </div>
        </ModalWindow>
    </section>
</template>

<script>
import CommunityButtons from "./CommunityButtons.vue";
import CommunitySearch from "./CommunitySearch.vue";
import CommunityStats from "./CommunityStats.vue";
import ModalWindow from "../modalwindow/ModalWindow.vue";
import CopyLink from "../CopyLink.vue";

export default {
    components: {
        CopyLink,
        ModalWindow,
        CommunityButtons,
        CommunitySearch
    },
    data() {
        return {
            closeLeaveModalEvent: 'bus-community-leave-show-event',
            currentRoute: window.location.pathname,
            hash: null,
            mediaSize: this.$simpleStore.getMediaSize(),
            showModalLeave: false,
            communityLogo: this.$simpleStore.transformImageWithCloudfront(
                120,
                120,
                this.$root.community.logo,
                this.$root
            ),
            communityLogoSrcSet: this.$simpleStore.transformImageWithCloudfront(
                120,
                120,
                this.$root.community.logo,
                this.$root,
                'srcset'
            )
        };
    },
    created() {
        window.addEventListener("resize", this.windowResize);
        this.$root.$on(this.closeLeaveModalEvent, this.toggleModalLeave);
    },
    destroyed() {
        window.removeEventListener("resize", this.windowResize);
    },
    methods: {
        windowResize() {
            this.mediaSize = this.$simpleStore.getMediaSize();
        },
        showInvitePanel() {
            this.$root.$emit('bus-show-invite-panel');
        },
        toggleModalLeave() {
            this.showModalLeave = !this.showModalLeave;
        },
        leave() {
            if (confirm('Are you sure you want to leave?')) {
                this.$simpleStore.clearMembershipCaches(this, this.$root.community.id);
                window.location = window.location.pathname + '/leave';
            }
        },
        join() {
            this.$simpleStore.join(this, this.$root.community.id);
            /*this.$http.get('/join/' + this.$root.community.id).then(response => {
                let data = response.data;
                let modalData = { cta: false };
                // user not logged in
                if (data.rU === false) {
                    modalData.title = 'You are not registered/logged in';
                    modalData.message = 'Please login or register to join a community';
                } else if (data.s === false) {
                    modalData.title = 'Already joined';
                    modalData.message = 'You have previously joined this community';
                } else {
                    modalData.title = 'Successfully joined';
                    modalData.message = 'You have successfully joined the ' + this.$root.community.name + ' community';
                    this.community.isMember = true;
                    let communityImgs = document.getElementsByClassName('c-community__img');
                    for (let i = 0; i < communityImgs.length; i++) {
                        communityImgs[i].classList.add('member');
                    }
                }
                this.$root.$emit('show-community-modal', modalData);
            }, response => {
                console.log('Errored:');
                console.log(response);
            });*/

            window.location.hash = 'join';
        }
    },
};
</script>
